export default {
      id: "google_pay-usage",
      viewBox: "0 0 46 18",
      url: __webpack_public_path__ + "sprite.svg#google_pay",
      toString: function () {
        return this.url;
      }
    }